import processOptionResolutions from "../process-option-resolutions";

/**
 * Get trigger parameters in parenthesis
 * @param {String | null} input
 * @param {MainClassProps} main
 * @param {Boolean} coordinates
 * @param {Boolean} useBounds
 * @returns {TriggerParametersProps | null}
 */
const getTriggerParameters = (input, main, coordinates, useBounds) => {
  if (!input) {
    return null;
  }

  /** Split each parameter into array */
  const split = input.split("╳");

  /** @example "target" => Map() */
  const values = /** @type {TriggerParametersProps} */ (
    processOptionResolutions(split, main, false, 0, coordinates, useBounds)
  );

  return values;
};

export default getTriggerParameters;
